var map = {
	"./background-gold-large.svg": "1dd9",
	"./background-platinum-large.svg": "6bd0",
	"./background-silver-large.svg": "dc97",
	"./gold.svg": "91a4",
	"./next-steps.svg": "475f",
	"./platinum.svg": "892b",
	"./silver.svg": "37e5",
	"./titanium.svg": "b171"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "957e";